import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";

import Home from "./Pages/Home";
import About from "./Pages/About";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import NotFound from "./Pages/NotFound";

import Seo from "./components/Seo";
import LanguageProvider from "./i18n/LanguageProvider";


function App() {
  return (
    <Router>
      <LanguageProvider>
        <ScrollToTop />

      {/* Global SEO injector (language-aware defaults via t.seo.*) */}
      <Seo />

        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/ar" element={<Home />} />
            <Route path="/ar/about" element={<About />} />
            <Route path="/ar/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/tr" element={<Home />} />
            <Route path="/tr/about" element={<About />} />
            <Route path="/tr/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </LanguageProvider>
    </Router>
  );
}

export default App;
